// extracted by mini-css-extract-plugin
export default {"label":"RegionsRow__label-ZDEcs","targetName":"RegionsRow__targetName-ziLn_"};